<template>
  <div class="page-trial-status dm-corp-page">
    <header-topbar />

    <div class="main-container m-container">
      <div v-if="flag === 'query'" class="query">
        <el-form
          key="queryForm"
          class="m-form"
          label-position="top"
          ref="queryForm"
          :model="queryForm"
          :rules="queryRules"
          @submit.native.prevent
        >
          <el-form-item label="请输入公司或学校名称" prop="company">
            <el-input type="text" :maxlength="50" v-model="queryForm.company"></el-input>
          </el-form-item>

          <el-form-item label="">
            <div class="m-btns">
              <el-button @click="gotoBack">取消</el-button>
              <el-button
                type="primary"
                :disabled="!queryForm.company"
                :loading="saving"
                @click="submitQueryForm('queryForm')"
                >查询</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 提交完成 -->
      <div v-if="flag === 'submit'" class="thank-item submit-succ">
        <i class="dmico-trial-success"></i>
        <h2>非常感谢，我们将马上开始审核</h2>
        <p class="msg">
          一般情况下，审核会在
          <b> 1-2 个工作日</b>
          内完成。您可以在“申请试用”入口点击“查询审核进度”查询审核结果。若有其他问题可以关注公众号：DiggMind，并点击公众号菜单栏“联系客服”联系我们。
        </p>

        <div class="wx-code">
          <img :src="gzcode" alt="" />
          <p>DiggMind 公众号</p>
        </div>
        <div class="foot-btn">
          <el-button type="primary" @click="gotoTrial">返回首页</el-button>
        </div>
      </div>

      <!-- 正在审核 -->
      <div v-if="flag === 'checking'" class="thank-item trial-checking">
        <i class="dmico-trial-doing"></i>
        <h2>正在审核中，请耐心等待……</h2>
        <p class="msg">
          一般情况下，审核会在
          <b> 1-2 个工作日</b>
          内完成。若有其他问题可以关注公众号：DiggMind，并点击公众号菜单栏“联系客服”联系我们。
        </p>

        <div class="wx-code">
          <img :src="gzcode" alt="" />
          <p>DiggMind 公众号</p>
        </div>
        <div class="foot-btn">
          <el-button type="primary" @click="gotoTrial">返回首页</el-button>
        </div>
      </div>

      <!-- 关闭试用 -->
      <div v-if="flag === 'close'" class="thank-item trial-close">
        <i class="dmico-trial-doing"></i>
        <h2>抱歉，您的试用申请已关闭</h2>
        <p class="msg msg-tip text-center">
          若有其他问题可以关注公众号：DiggMind，并点击公众号菜单栏“联系客服”联系我们。
        </p>
      </div>

      <!-- 申请通过 -->
      <div v-if="flag === 'pass'" class="thank-item trial-pass">
        <i class="dmico-trial-ok"></i>
        <h2>恭喜！您的申请已通过</h2>

        <section class="system-result">
          <ul class="result-g">
            <li class="g-item g-title">
              <h3>学校心理系统管理后台登录网址</h3>
              <p class="tip">学校心教负责人请访问这个网址</p>
            </li>
            <li class="g-item">
              <p class="url">{{ admin_url }}</p>
              <div class="g-btns">
                <el-button @click="doCopy(admin_url)">复制链接</el-button>
                <el-button type="primary" @click="openBrowser(admin_url)">在浏览器打开</el-button>
              </div>
            </li>
          </ul>

          <ul class="result-g">
            <li class="g-item g-title">
              <h3>学校心理系统用户前台登录网址</h3>
              <p class="tip">学生、教师等普通用户请访问这个网址</p>
            </li>
            <li class="g-item">
              <p class="url label-url"><label>电脑版</label>{{ pc_url }}</p>
              <div class="g-btns">
                <el-button @click="doCopy(pc_url)">复制链接</el-button>
                <el-button type="primary" @click="openBrowser(pc_url)">在浏览器打开</el-button>
              </div>
            </li>

            <li class="g-item">
              <p class="url label-url"><label>手机版</label>{{ mobile_url }}</p>
              <div class="g-btns">
                <el-button @click="doCopy(mobile_url)">复制链接</el-button>
                <el-button type="primary" @click="createMobileCode('mobileQrcode', mobile_url)"
                  >下载二维码</el-button
                >
              </div>
            </li>

            <li class="g-item g-share">
              <div class="qrcode">
                <i class="dmlog" :style="{ backgroundImage: `url(${dmlogo})` }"></i>
                <div id="shareQrcode"></div>
              </div>
              <!--<img class="gzcode" :src="gzcode" alt="" />-->
              <div class="wxshare">
                <p>扫码访问手机版前台网址</p>
                <p class="share-icon">
                  <i class="dmico-share-wx s-icon"></i>
                  <!--<i class="dmico-share-sina s-icon"></i>-->
                  <!--<i class="dmico-share-qq s-icon"></i>-->
                </p>
              </div>
            </li>
          </ul>

          <ul class="result-g">
            <li class="g-item g-title">您可以填写邮箱地址，我们会把以上信息发送到您的邮箱</li>
            <li class="g-item">
              <el-input v-model="mail" placeholder="输入邮箱地址"></el-input>
              <div class="g-btns">
                <el-button type="primary" :disabled="!mail" :loading="sending" @click="sendmailbox"
                  >发送到邮箱</el-button
                >
              </div>
            </li>
          </ul>
          <p class="msg msg-tip text-center">
            若有其他问题可以关注公众号：DiggMind，并点击公众号菜单栏“联系客服”联系我们。
          </p>
        </section>
      </div>
    </div>

    <Message :show.sync="showMessage" :text="messageText" />

    <Dialog :show.sync="showDialog">
      <div class="qrcode-body">
        <div class="qrcode-container">
          <i class="dmlog" :style="{ backgroundImage: `url(${dmlogo})` }"></i>
          <div id="mobileQrcode" class="mobile-qrcode"></div>
        </div>
        <p class="tip">温馨提示：鼠标右键另存为图片</p>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import QRCode from 'qrcodejs2'
import HeaderTopbar from 'components/common/HeaderTopbar'
import Message from 'components/common/Message'
import Dialog from 'components/common/Dialog'

import { getTrialApplyStatus, postTrialSendMail } from '@/api/index.js'

export default {
  name: 'Status',
  components: { HeaderTopbar, Message, Dialog },

  data() {
    return {
      // submit/checking/close/pass
      flag: '',
      saving: false,
      sending: false,

      queryForm: {},
      queryRules: {},

      admin_url: '',
      mobile_url: '',
      pc_url: '',

      mail: '',

      showMessage: false,
      messageText: '',

      showDialog: false
    }
  },

  computed: {
    gzcode() {
      return require('assets/images/wx-gzcode.jpeg')
    },

    dmlogo() {
      return require('assets/images/logo-plain.png')
    },

    inviteChannelCode() {
      return this.$route.query['invite_channel_code']
    }
  },

  methods: {
    gotoTrial() {
      this.$router.push({
        name: 'trial',
        query: { invite_channel_code: this.inviteChannelCode }
      })
    },

    gotoBack() {
      window.history.back()
    },

    openBrowser(url) {
      window.open(url)
    },

    // 复制到剪切板
    doCopy(copyUrl) {
      if (!copyUrl) return

      this.$copyText(copyUrl).then(
        () => {
          this.messageText = '已复制到剪切板。'
          this.showMessage = true
        },
        () => {
          this.messageText = '复制失败，请手动选择复制。'
          this.showMessage = true
        }
      )
    },

    submitQueryForm(formRef) {
      this.$refs[formRef].validate(valid => {
        if (!valid) {
          return false
        }

        this.queryStatus(this.queryForm['company'])
      })
    },

    queryStatus(company) {
      if (this.saving) return

      this.saving = true
      getTrialApplyStatus(company)
        .then(res => {
          this.saving = false
          let statusCode = res.data['status']
          if (statusCode === 10) {
            this.flag = 'checking'
          } else if (statusCode === 11) {
            this.flag = 'pass'
            let channelCode = res.data['channel_code']

            this.admin_url = `http://${channelCode}.biz.diggmind.com`
            this.mobile_url = `https://wx.diggmind.com/biz?channel_code=${channelCode}`
            this.pc_url = `http://biz.diggmind.com/?channel_code=${channelCode}`

            this.$nextTick(() => {
              this.createQrCode('shareQrcode', this.mobile_url, 100)
            })
          } else if (statusCode === 12) {
            this.flag = 'close'
          }
        })
        .catch(() => {
          this.messageText = '未查询到任何结果。'
          this.saving = false
          this.showMessage = true
        })
    },

    createMobileCode(domID, text) {
      this.createQrCode(domID, text, 200)
      this.showDialog = true
    },

    createQrCode(domID, text, width) {
      document.getElementById(domID).innerHTML = ''
      new QRCode(domID, {
        text: text,
        width: width ? width : 100,
        height: width ? width : 100,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },

    sendmailbox() {
      let reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!reg.test(this.mail)) {
        this.messageText = '邮箱地址格式错误，请重新输入'
        this.showMessage = true
        return
      }

      if (this.sending) return

      this.sending = true
      postTrialSendMail(this.queryForm.company, this.mail)
        .then(() => {
          this.sending = false
          this.messageText = '发送成功，请到邮箱查收。'
          this.showMessage = true
        })
        .catch(() => {
          this.sending = false
          this.messageText = '发送失败，请稍后再试。'
          this.showMessage = true
        })
    }
  },

  mounted() {},

  created() {
    this.flag = this.$route.query['flag'] || ''
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';

.page-trial-status.dm-corp-page {
  padding-bottom: 20px;
  .m-container {
    padding-top: 60px;
  }

  .m-form {
    margin: 0 auto 30px;
    max-width: 380px;

    .block {
      display: block;
    }

    .el-form-item__label {
      font-weight: bold;
      line-height: 22px;
    }

    .m-btns {
      padding-top: 10px;
      text-align: center;
      .el-button + .el-button {
        margin-left: 20px;
      }
    }
  }

  .thank-item {
    margin: auto;
    text-align: center;

    h2 {
      margin: 20px 0;
      font-size: 22px;
      font-weight: 600;
      line-height: 25px;
    }

    .msg {
      text-align: justify;
      line-height: 21px;
      margin-bottom: 30px;
      b {
        color: #1c67fe;
        font-weight: normal;
      }
      &.msg-tip {
        font-size: 14px;
        color: #999999;
      }
      &.text-center {
        text-align: center;
      }
    }
  }

  .wx-code {
    margin-bottom: 40px;
    color: #999;
    img {
      width: 170px;
      margin-bottom: 10px;
      border: 1px solid #eee;
      border-radius: 2px;
    }
    p {
      text-align: center;
    }
  }

  .thank-item.submit-succ,
  .thank-item.trial-checking {
    max-width: 380px;
  }

  .thank-item.trial-close,
  .thank-item.trial-pass {
    max-width: 640px;
  }

  .system-result {
    padding-top: 10px;
  }
  .result-g + .result-g {
    padding-top: 30px;
    border-top: 1px solid #dddddd;
  }
  .result-g {
    padding-bottom: 30px;
    .g-item {
      margin-bottom: 20px;
      display: flex;
      justify-content: flex-start;
      flex-flow: row nowrap;
      font-size: 14px;
      &:last-child {
        margin-bottom: 0;
      }

      .url {
        position: relative;
        flex: auto;
        padding: 10px 20px;
        line-height: 20px;
        background-color: #f8f8f8;
        border-radius: 4px;

        &.label-url {
          padding-left: 60px;
        }

        label {
          position: absolute;
          top: 8px;
          left: 5px;
          display: inline-block;
          line-height: 24px;
          font-size: 12px;
          padding: 0 5px;
          color: #fff;
          border-radius: 4px;
          background-color: #333333;
          user-select: none;
        }
      }

      .g-btns {
        flex: none;
        margin-left: 10px;
      }

      .el-button {
        width: 100px;
        height: 40px;
        padding: 0;
      }

      .el-button + .el-button {
        margin-left: 10px;
      }

      .el-button--primary {
        width: 120px;
      }

      @media screen and (max-width: $mobile-max-width) {
        flex-flow: row wrap;
        .url {
          width: 100%;
        }
        .g-btns {
          margin-top: 10px;
          margin-left: 0;
          justify-self: flex-end;
        }
      }
    }

    .g-title {
      display: block;
      margin-bottom: 15px;
      h3 {
        font-weight: bold;
        font-size: 18px;
      }
      .tip {
        font-size: 13px;
        color: #999999;
      }
    }

    .g-share {
      .qrcode {
        position: relative;
        min-width: 100px;
        min-height: 100px;
        padding: 5px;
        border: 1px solid #eee;
        border-radius: 2px;
        .dmlog {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 26px;
          height: 24px;
          transform: translate(-50%, -50%);
          border-radius: 3px;
          background-size: 20px auto;
          background-repeat: no-repeat;
          background-position: center;
          background-color: #fff;
        }
      }

      .gzcode {
        width: 100px;
        height: 100px;
        border: 1px solid #eee;
        border-radius: 2px;
      }

      .wxshare {
        margin-left: 20px;
        align-self: center;
        font-weight: bold;
        .s-icon + .s-icon {
          margin-left: 8px;
        }
        .share-icon {
          margin-top: 10px;
        }
      }
    }
  }

  .qrcode-container {
    position: relative;
    min-width: 210px;
    min-height: 210px;
    padding: 8px;
    text-align: center;
    border-radius: 2px;
    background-color: #fff;

    .dmlog {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 40px;
      height: 35px;
      transform: translate(-50%, -50%);
      border-radius: 3px;
      background-size: 30px auto;
      background-repeat: no-repeat;
      background-position: center;
      background-color: #fff;
    }
  }

  .qrcode-body {
    .tip {
      padding-bottom: 5px;
      text-align: center;
      font-size: 14px;
      color: #999;
    }
  }
}
</style>
